let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1Dr4K")).then(() => parcelRequire('bQw5s'));